import { Sparkles, Search, FileText, Network, Home, MessageCircle } from 'lucide-react';

export type PublicTab = {
  label: string;
  href: string;
  icon: React.ElementType;
};

export type LockedTab = {
  label: string;
  icon: React.ElementType;
  locked: true;
};

export type Tab = PublicTab | LockedTab;

/** Guest navigation: locked tabs pop the signup modal instead of navigating. */
export const TABS: Tab[] = [
  { label: 'Dashboard', icon: Home, locked: true },
  { label: 'Messages', icon: MessageCircle, locked: true },
  { label: 'Navigator', href: '/care-navigator', icon: Sparkles },
  { label: 'Service Providers', href: '/search-providers', icon: Search },
  { label: 'Resources', href: '/resources', icon: FileText },
  { label: 'My Network', icon: Network, locked: true },
];

export const LOCKED_TAB_HINT = 'Create an account to get access';
